import { ReportInstanceStatuses } from '@xbs/xbs-enums';

export class ReportGenerationConstants {
    public static readonly REPORT_STATUS_BY_NUMBER = {
      1: ReportInstanceStatuses.ByName.Pending.Name,
      2: ReportInstanceStatuses.ByName.Generated.Name,
      3: ReportInstanceStatuses.ByName.Failed.Name,
      4: ReportInstanceStatuses.ByName.Uploaded.Name,
      5: ReportInstanceStatuses.ByName.Converting.Name
    };

    public static readonly REPORT_STATUS_BY_NAME = {
      PENDING: 1,
      GENERATED: 2,
      FAILED: 3,
      UPLOADED: 4,
      CONVERTING: 5
    };

    public static readonly TOOLTIP_TEXT = {
      [ReportInstanceStatuses.ByName.Generated.Name]: 'The report has been generated and is available for use.',
      [ReportInstanceStatuses.ByName.Pending.Name]: 'The report is being generated.',
      [ReportInstanceStatuses.ByName.Failed.Name]: 'The report failed to generate. Please try again.',
      [ReportInstanceStatuses.ByName.Uploaded.Name]: 'The report has been uploaded to the Working Repository.',
      [ReportInstanceStatuses.ByName.Converting.Name]: 'The report is being converted.'
    };

    public static readonly TOOLTIP_TEXT_BY_NUMBER = {
      '1': 'The report is being generated.',
      '2': 'The report has been generated and is available for use.',
      '3': 'The report failed to generate. Please try again.',
      '4': 'The report has been uploaded to the Working Repository.',
      '5': 'The report is being converted.'
    };
    public static readonly REPORT_RESOURCE_ROUTES = {
      MASTER_FILE: 'master-file-reports/',
      PLANNING: 'planning-file-reports/',
      LOCAL_FILE: 'internal-local-file-reports/'
    };
}
